import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import $ from 'jquery';
import Popper from 'popper.js';
import 'bootstrap/dist/js/bootstrap.bundle';
import {
  Switch,
  Route
} from "react-router-dom";
// import { useState } from 'react'
import { useLocation } from 'react-router';
import { AnimatePresence } from 'framer-motion';
import React from 'react'

import Navs from './Components/Navs'
import Home from './Components/Sections/Home'
import About from './Components/Sections/About'
import Portfolio from './Components/Sections/Portfolio'
import Resume from './Components/Sections/Resume'
import Contact from './Components/Sections/Contact'

function App() {
  const location = useLocation()
  return (
    <div className="App">
      <Navs />
      <AnimatePresence exitBeforeEnter>
        <Switch location={location} key={location.key}>
          <Route path='/' exact>
            <Home />
          </Route>
          <Route path='/about'>
            <About />
          </Route>
          <Route path='/portfolio'>
            <Portfolio />
          </Route>
          <Route path='/resume'>
            <Resume />
          </Route>
          <Route path='/contact'>
            <Contact />
          </Route>
        </Switch>
      </AnimatePresence>
    </div>
  );
}

export default App;
